
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			ToolbarService
		};
	},
	computed: {
		drawer: {
			get():boolean | number {
				if (this.$wf.isSmDown) {
					return this.ToolbarService.drawer;
				}
				return true;
			},
			set(value:boolean | number) {
				this.ToolbarService.drawer = value;
			}
		}
	},
	watch: {
		"$route": {
			immediate: true,
			deep: true,
			handler() {
				ToolbarService.title = this.$ct("title");
				if (this.$wf.isSmDown) {
					this.drawer = false;
				}
			}
		},
		"$wf.isSmDown"() {
			this.drawer = !this.$wf.isSmDown;
		}
	},
	methods: {
		goToRoadMap(){
			window.open("https://winfakt.be/whatsnew", "_blank");
		}
	},
	created() {
		this.drawer = !this.$wf.isSmDown;
	},
	i18nEx: {componentPrefix: "views.SupportRoute"},
});
